module.exports = __webpack_public_path__ + "img/H26-1.png";